// extracted by mini-css-extract-plugin
export var chip = "_cg-0";
export var filterDropdown = "_cg-5";
export var filterItem = "_cg-6";
export var icon = "_cg-1";
export var removeButton = "_cg-3";
export var removeIcon = "_cg-4";
export var separator = "_cg-2";